<template>
<div style="margin: 16px; display: flex; justify-content: center;">
    <el-card shadow="hover" style="padding: 0 16px 16px 16px; width: 100%; max-width: 800px; min-height: 400px;">
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
        <el-page-header @back="back" :content="update == null ? '' : update.update_title"></el-page-header>
        <div v-if="update != null && !update.published" style="display: flex;">
          <el-button-group>
            <el-button size="small" type="info" icon="el-icon-edit" @click="editUpdate"></el-button>
            <el-button v-if="!update.approved && update.approver_position == user.primary_position.o_id" size="small" type="success" @click="approveUpdate">Approve</el-button>
            <el-button size="small" type="danger" @click="deleteUpdate">Delete</el-button>
          </el-button-group>
        </div>
      </div>
      <div>
        <hr style="margin-top: 16px; margin-bottom: 8px;" />
        <el-row class="update-container" v-loading="update == null">
          <div v-if="update != null" class="update-body" v-html="update.update_text"></div>
        </el-row>
      </div>
    </el-card>
    <nxs-update-edit v-if="update != null" :update="update" :dialogVisible="dialogVisible" @close="closeDialog"></nxs-update-edit>
  </div>
</template>


<script>
import {mapFields} from 'vuex-map-fields';
import nxsUpdateEdit from "./UpdateEdit.vue";
export default {
    props: ["id"],
    components: {nxsUpdateEdit},
    data() {
        return {
            update: null,
            dialogVisible: false
        };
    },
    computed: {
        ...mapFields([
            'user'
        ])
    },
    mounted() {
        if(this.update == null){
            this.pullUpdate();
        }
    },
    methods: {
        back() {
            //This.$router.push('/home/updates')
            this.$router.go(-1);
        },
        pullUpdate() {
            this.axios
                .get(
                    "/api/v1/updates/" + this.id,
                    {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    }
                )
                .then((response) => {
                    this.update = response.data;
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.message,
                        type: "error"
                    });
                });
        },
        closeDialog(updateObj) {
            this.dialogVisible = false;
            if(updateObj != null) {
                this.update = updateObj;
            }
        },
        editUpdate() {
            this.dialogVisible = true;
        },
        approveUpdate() {
            this.axios
                .put("/api/v1/updates/approve/" + this.update.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.update = response.data;
                    this.$message({
                        showClose: true,
                        message: "Update Approved",
                        type: "success"
                    });
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.message,
                        type: "error"
                    });
                });
        },
        deleteUpdate() {
            this.axios
                .delete("/api/v1/updates/" + this.update.o_id, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.back();
                    this.$message({
                        showClose: true,
                        message: "Update Deleted",
                        type: "success"
                    });
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: err.response.data.message,
                        type: "error"
                    });
                });
        }
    }
}
</script>
